import React from "react";
import "./Insights.css";
import artificial from "../../../assets/products/artificial.png";
import enhance from "../../../assets/products/enhanced.png";
import adapt from "../../../assets/products/adapt.png";

const Insights = () => {
  const data = [
    {
      id: 1,
      title: "Artificially Intelligent",
      description:
        "Our AI-driven insights help you make data-driven decisions effortlessly and unlock patterns, trends, and opportunities you might have missed.",
      img: artificial,
    },
    {
      id: 2,
      title: "Enhanced Professional Delivery",
      description:
        "FOCII provides you the tools and insights that helps you to understand your audience. You'll effortlessly analyze engagement metrics, uncover trends, and craft strategies and deliver like a pro.",
      img: enhance,
    },
    {
      id: 3,
      title: "Adapt On The Fly",
      description:
        "With FOCII’s real-time analytics, you can adapt and enhance your strategies on the fly.",
      img: adapt,
    },
  ];
  return (
    <section className="gray-background-bg d-flex justify-content-center">
      <div className="product-components-max-width">
        <h1 className="primary-light-text">AI-powered Insights</h1>
        {data.map((data) => (
          <div key={data.id} className="row insights-card">
            <div className="col-lg-4 col-md-6">
              <img src={data.img} alt="" />
            </div>
            <div className="col-lg-8 col-md-6">
       
                <h6 className="primary-light-text">{data.title}</h6>
                <p className="secondary-light-text">{data.description}</p>
           
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Insights;
